<template>
  <v-container class="limited">
    <dados-beneficiario></dados-beneficiario>

    <v-stepper :value="stepParcelamento">
      <v-stepper-header>
        <v-stepper-step
          v-for="(step, index) in steps"
          :key="index"
          :complete="stepComplete(index + 1)"
          :step="index + 1"
          :rules="[value => !!step.valid]"
        >
          {{ step.name }}
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form v-model="valid" lazy-validation ref="form">
            <corrigir-cobranca
              :dadosFatura="faturaSelected"
              :numeroContrato="dadosBeneficiario.contratoId"
            />
            <v-layout align-center justify-end row fill-height>
              <v-btn flat @click="onClickVoltar">
                Anterior
              </v-btn>
              <v-btn color="primary" @click="onClickNextStep2">
                Próximo
              </v-btn>
            </v-layout>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-form v-model="valid" lazy-validation ref="form2">
            <selecionar-beneficiario
              v-bind="{
                selecionarBeneficiario
              }"
              :numeroContrato="dadosBeneficiario.contratoId"
            />
            <v-layout align-center justify-end row fill-height>
              <v-btn flat @click="previousStep">
                Anterior
              </v-btn>
              <v-btn color="primary" @click="onClickNextStep3">
                Próximo
              </v-btn>
            </v-layout>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="3">
          <visualizar-parcelamento v-bind="{ visualizaParcelamento }" />
          <v-layout align-center justify-end row fill-height>
            <v-btn flat @click="previousStep">
              Anterior
            </v-btn>
            <v-btn color="primary" @click="onClickConcluiParcelamento">
              Próximo
            </v-btn>
          </v-layout>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

import {
  createParcelamentoFatura,
  atualizarQtdParcelamento,
  concluiParcelamento
} from "@/services/plapiconnect";
import { formatDate } from "@/utils/date";

import DadosBeneficiario from "@/components/BeneficiaryData";
import CorrigirCobranca from "./corrigir-cobranca.vue";
import SelecionarBeneficiario from "./selecionar-beneficiario";
import VisualizarParcelamento from "./visualizar-parcelamento";

export default {
  name: "ParcelarFaturas",
  props: {
    faturaId: String
  },
  components: {
    CorrigirCobranca,
    DadosBeneficiario,
    SelecionarBeneficiario,
    VisualizarParcelamento
  },
  data() {
    return {
      formatDate,
      valid: true,
      steps: [
        { name: "Corrigir Cobrança", valid: true },
        { name: "Selecionar Beneficiário", valid: true },
        { name: "Resumo Parcelamento", valid: true }
      ]
    };
  },
  computed: {
    ...portalStore.mapState([
      "stepParcelamento",
      "selecionarBeneficiario",
      "visualizaParcelamento"
    ]),
    ...portalStore.mapGetters([
      "faturaSelected",
      "payloadQtdParcelasBeneficiario"
    ]),
    ...beneficiarioStore.mapState(["dadosBeneficiario"])
  },
  created() {
    this.resetStep();
  },
  methods: {
    ...portalStore.mapMutations(["nextStep", "previousStep", "resetStep"]),
    stepComplete(step) {
      return this.stepParcelamento > step;
    },
    onClickVoltar() {
      this.$router.push({
        name: "faturas"
      });
    },
    async onClickNextStep2() {
      await this.$refs?.form?.validate();

      if (this.valid) {
        await createParcelamentoFatura(
          {
            payload: `{"fatura" : "${
              this.faturaSelected?.numeroDocumento
            }", "codigoParcelamento": "${
              this.faturaSelected?.codigoParcelamento
            }", "dataPrimVencimento": "${formatDate(
              this.faturaSelected?.dataPrimVencimento
            )}", "dataBaseParcelamento": "${
              this.faturaSelected?.dataBaseParcelamento
            }", "valorEntrada": "${this.faturaSelected?.valorEntrada.replace(
              /\./g,
              ""
            )}"}`,
            nextStep: true
          },
          this.$store
        );
      }
    },
    async onClickNextStep3() {
      await this.$refs?.form2?.validate();

      const payloadQtdParcelasBeneficiario = this.selecionarBeneficiario.map(
        beneficiario => `{
        "numeroFatura": "${beneficiario.fatura}",
        "codigoBeneficiario": "${beneficiario.codigoBeneficiario}",
        "qtd": "${beneficiario.qtd}"
        }`
      );

      if (this.valid) {
        await atualizarQtdParcelamento(
          {
            payload: `{"codigoParcelamento": "${
              this.faturaSelected?.codigoParcelamento
            }",
          "quantidades": [${payloadQtdParcelasBeneficiario}]}`
          },
          this.$store
        );
      }
    },
    async onClickConcluiParcelamento() {
      await concluiParcelamento(
        {
          payload: `{"codigoParcelamento": "${
            this.faturaSelected?.codigoParcelamento
          }"}`
        },
        this.$store,
        this.$router
      );
    }
  }
};
</script>
